import { useEffect, useMemo, useRef } from "react"
import { useLocalStorageValue } from "tools/store/localStorageRegistry"
import { isCategoryVisible } from "../../zoomLod"
import { useAirspaceLayer } from "../../useAirspaceLayer"
import { TFR_LAYER_ID } from "../../layerIds"
import { fetchAndCacheTfrs, useTfrCache } from "./tfrCache"

export const useTfrLayer = (enabled: boolean) => {
    const abortRef = useRef<AbortController | null>(null)

    const airspaceFilters = useLocalStorageValue("airspaceFilters")
    const tfrsCategoryVisible = airspaceFilters.categoriesVisible.tfrs
    const tfrTypesVisible = airspaceFilters.tfrs

    useEffect(() => {
        if (!tfrsCategoryVisible) return
        abortRef.current?.abort()
        const abortController = new AbortController()
        abortRef.current = abortController
        fetchAndCacheTfrs({ abortController })
        return () => {
            abortRef.current?.abort()
            abortRef.current = null
        }
    }, [tfrsCategoryVisible])

    const cache = useTfrCache()
    const visibleFeatures = useMemo(
        () =>
            tfrsCategoryVisible
                ? [...cache.values()]
                      .filter((cached) =>
                          isCategoryVisible(cached.properties.tfrType, tfrTypesVisible)
                      )
                      .map((cached) => cached.feature)
                : [],
        [cache, tfrTypesVisible, tfrsCategoryVisible]
    )

    return useAirspaceLayer({ type: TFR_LAYER_ID, visibleFeatures, enabled })
}
